export function isBlockAnnotation(annotation) {
    return !isInlineAnnotation(annotation);
}
export function isInlineAnnotation(annotation) {
    return annotation.hasOwnProperty("lineNumber");
}
export function isWhitespace(token) {
    return typeof token === "string";
}
